import { ReactNode } from 'react';
import * as S from './styles';

export type BadgeProps = {
  $size: 1 | 2 | 3;
  $rounded: boolean;
  $variant: 'solid' | 'soft' | 'surface' | 'outline' | 'ghost' | 'warning';
  $color: string;
  $highContrast: boolean;
  $iconStart?: ReactNode;
  $text: string;
  $textColor?: string;
};

export default function Badge(props: BadgeProps) {
  const { $text } = props;
  return (
    <S.Container {...props}>
      <S.Texto {...props}>{$text}</S.Texto>
    </S.Container>
  );
}
